// Shopifyテーマ - リンククリックを機能させるドラッグスクロール
document.addEventListener('DOMContentLoaded', function() {
  // ドラッグスクロールを適用する要素のセレクタを配列で定義
  const scrollContainerSelectors = [
    '.cMain__mv--list',
    '.cMain__information--list',
    '.cMain__contents--m--list',
    '.cMain__onlinestore--feature',
    '.cMain__pickup',
    // 必要に応じて他のセレクタを追加
  ];
  
  // 各セレクタに一致する要素に対してドラッグスクロールを適用
  scrollContainerSelectors.forEach(selector => {
    const containers = document.querySelectorAll(selector);
    
    containers.forEach(container => {
      enableDragScroll(container);
    });
  });
  
  // ドラッグスクロール機能を有効化する関数
  function enableDragScroll(element) {
    if (!element) return;
    
    // 要素にスクロール可能なスタイルを適用
    element.classList.add('drag-scroll-enabled');
    
    let isDown = false;
    let startX;
    let scrollLeft;
    let moveDistance = 0;
    let startTime;
    
    // マウスダウン時の処理
    element.addEventListener('mousedown', (e) => {
      // リンク要素上のクリックはスクロール処理を行わない
      if (e.target.tagName === 'A' || e.target.closest('a')) {
        return;
      }
      
      isDown = true;
      startTime = Date.now();
      element.classList.add('dragging');
      startX = e.pageX - element.offsetLeft;
      scrollLeft = element.scrollLeft;
      moveDistance = 0;
    });
    
    // マウスが要素から離れた時の処理
    element.addEventListener('mouseleave', () => {
      isDown = false;
      element.classList.remove('dragging');
    });
    
    // マウスアップ時の処理
    element.addEventListener('mouseup', (e) => {
      isDown = false;
      element.classList.remove('dragging');
    });
    
    // マウス移動時の処理
    element.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      
      const x = e.pageX - element.offsetLeft;
      const walk = (x - startX);
      moveDistance += Math.abs(walk);
      
      // 一定以上の移動があった場合のみスクロール処理
      if (moveDistance > 5) {
        e.preventDefault();
        element.scrollLeft = scrollLeft - walk;
      }
    });
    
    // タッチデバイス対応
    let touchIdentifier = null;
    
    element.addEventListener('touchstart', (e) => {
      // リンク要素上のタッチはスクロール処理を行わない
      if (e.target.tagName === 'A' || e.target.closest('a')) {
        return;
      }
      
      // 最初のタッチポイントのみを追跡
      if (touchIdentifier === null && e.touches.length === 1) {
        touchIdentifier = e.touches[0].identifier;
        isDown = true;
        startTime = Date.now();
        element.classList.add('dragging');
        startX = e.touches[0].pageX - element.offsetLeft;
        scrollLeft = element.scrollLeft;
        moveDistance = 0;
      }
    });
    
    element.addEventListener('touchend', (e) => {
      // 追跡中のタッチが終了した場合のみリセット
      if (touchIdentifier !== null) {
        for (let i = 0; i < e.changedTouches.length; i++) {
          if (e.changedTouches[i].identifier === touchIdentifier) {
            isDown = false;
            element.classList.remove('dragging');
            touchIdentifier = null;
            break;
          }
        }
      }
    });
    
    element.addEventListener('touchcancel', (e) => {
      // 追跡中のタッチがキャンセルされた場合のみリセット
      if (touchIdentifier !== null) {
        for (let i = 0; i < e.changedTouches.length; i++) {
          if (e.changedTouches[i].identifier === touchIdentifier) {
            isDown = false;
            element.classList.remove('dragging');
            touchIdentifier = null;
            break;
          }
        }
      }
    });
    
    element.addEventListener('touchmove', (e) => {
      // 追跡中のタッチポイントのみ処理
      if (!isDown || touchIdentifier === null) return;
      
      let touch = null;
      for (let i = 0; i < e.touches.length; i++) {
        if (e.touches[i].identifier === touchIdentifier) {
          touch = e.touches[i];
          break;
        }
      }
      
      if (touch) {
        const x = touch.pageX - element.offsetLeft;
        const walk = (x - startX);
        moveDistance += Math.abs(walk);
        
        // 一定以上の移動があった場合のみスクロール処理
        if (moveDistance > 10) {
          e.preventDefault();
          element.scrollLeft = scrollLeft - walk;
        }
      }
    });
  }
  
  // MutationObserverを使用して動的に追加された要素に対応
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // 要素ノードの場合のみ
            scrollContainerSelectors.forEach(selector => {
              if (node.matches && node.matches(selector)) {
                enableDragScroll(node);
              }
              
              const containers = node.querySelectorAll(selector);
              containers.forEach(container => {
                enableDragScroll(container);
              });
            });
          }
        });
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});



// iPad
(function() {
  var ua = window.navigator.userAgent;
  var isIpad = /iPad/.test(ua) || 
               (/Macintosh/.test(ua) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1);

  if (isIpad) {
    // iPad ならば、-webkit-text-strokeを打ち消すスタイルを追加
    var styleSheet = document.createElement('style');
    styleSheet.innerHTML = `
      .some-text {
        -webkit-text-stroke: 0 !important;
      }
    `;
    document.head.appendChild(styleSheet);
  }
})();

// カーニング
const kakkoElements = document.querySelectorAll('.cMain__article h2, .cMain__contents--m--title, .cMain__information--list--title, .cMain__article--list--title, .cMain__products--title, .cMain__recommended--title');
kakkoElements.forEach(element => {
    element.innerHTML = element.innerHTML.replace(/】(?![】<])/g, '】<br>');
});

function processTextNodes(node) {
    if (node.nodeType === 3) { 
        let newText = node.textContent
            .replace(/】(?![】\s])/g, ' 】 ')
            .replace(/【(?![【\s])/g, '【 ')
            .replace(/(?!^)(?<!\s)【/g, ' 【 ')
            .replace(/」(?![」\s])/g, ' 」 ')
            .replace(/「(?![「\s])/g, '「 ')
            .replace(/(?!^)(?<!\s)「/g, ' 「 ')
            .replace(/』(?![』\s])/g, ' 』 ')
            .replace(/『(?![『\s])/g, '『 ')
            .replace(/(?!^)(?<!\s)『/g, ' 『 ');
            
        if (newText !== node.textContent) {
            node.textContent = newText;
        }
    } else {
        node.childNodes.forEach(child => processTextNodes(child));
    }
}
processTextNodes(document.body);
  
// 価格非表示
// AJAX完了を監視する関数
const observeAjaxCompletion = (callback) => {
  // MutationObserverの設定
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.target.classList.contains('cMain__recommended--list')) {
        hideZeroPrices();
      }
    });
  });

  // 監視対象の要素
  const targetNode = document.querySelector('.cMain__recommended--list');
  if (targetNode) {
    // オブザーバーの設定
    const config = { 
      childList: true,
      subtree: true 
    };

    // 監視開始
    observer.observe(targetNode, config);
  }
};

// 価格が0円の要素を非表示にする関数
const hideZeroPrices = () => {
  document.querySelectorAll('.cMain__recommended--price').forEach(priceElement => {
    if (priceElement.textContent.trim() === '¥0' || priceElement.textContent.trim() === '¥0.00') {
      priceElement.style.display = 'none';
    }
  });
};

// DOMContentLoadedイベントで監視を開始
document.addEventListener('DOMContentLoaded', () => {
  observeAjaxCompletion();
  // 初回実行
  hideZeroPrices();
});
  
// ページ全体で右クリックを無効化
document.addEventListener('contextmenu', function (e) {
    e.preventDefault();
});

document.querySelectorAll('img').forEach(function (img) {
    img.setAttribute('draggable', 'false');
    img.addEventListener('dragstart', function (e) {
        e.preventDefault();
    });
});

// scroll
document.addEventListener('DOMContentLoaded', function() {
    // 対象となる要素を取得
    const cart = document.querySelector('.cCart');
    const announcementBar = document.querySelector('.announcement-bar');
    
    // スクロール制御用の変数
    let lastScrollY = window.scrollY;
    let ticking = false;
    
    window.addEventListener('scroll', function() {
        if (!ticking) {
            window.requestAnimationFrame(function() {
                const currentScrollY = window.scrollY;
                
                // 下スクロール時に非表示、上スクロール時に表示
                if (currentScrollY > lastScrollY) {
                    // カートの要素が存在する場合のみクラスを追加
                    if (cart) {
                        cart.classList.add('is-hidden');
                    }
                    
                    // お知らせバーの要素が存在する場合のみクラスを追加
                    if (announcementBar) {
                        announcementBar.classList.add('is-hidden');
                    }
                } else {
                    // カートの要素が存在する場合のみクラスを削除
                    if (cart) {
                        cart.classList.remove('is-hidden');
                    }
                    
                    // お知らせバーの要素が存在する場合のみクラスを削除
                    if (announcementBar) {
                        announcementBar.classList.remove('is-hidden');
                    }
                }
                
                lastScrollY = currentScrollY;
                ticking = false;
            });
            ticking = true;
        }
    });
});

$(document).ready(function() {
  const isMobileSize = () => $(window).width() <= 600;

  // 初期設定とメニュー状態の更新
  function setupMenu() {
    // トグルボタンの追加
    $('.cGnav__top--2nd > li').each(function() {
      if ($(this).find('.cGnav__top--3rd').length && !$(this).find('.toggle-btn').length) {
        $('<span class="toggle-btn">＋</span>').insertAfter($(this).children('a'));
      }
    });

    $('.cGnav__top--1st > li').each(function() {
      if ($(this).find('.cGnav__top--2nd').length && !$(this).find('.mobile-toggle-btn').length) {
        $('<span class="mobile-toggle-btn">＋</span>').insertAfter($(this).children('a'));
      }
    });

    // 画面サイズに応じた表示設定
    if (isMobileSize()) {
      $('.cGnav__top--2nd, .cGnav__top--3rd').hide();
    } else {
      $('.cGnav__top--2nd').show();
      $('.cGnav__top--3rd').hide();
    }
  }

  // 第3階層メニューの操作
  $(document).on('click', '.toggle-btn', function(e) {
    e.preventDefault();
    const $item = $(this).parent('li');
    const $menu = $item.find('.cGnav__top--3rd');
    const willOpen = !$menu.is(':visible');

    // 他のメニューを閉じる
    $('.cGnav__top--2nd > li').not($item).find('.cGnav__top--3rd').slideUp(300);
    $('.cGnav__top--2nd > li').not($item).removeClass('is-expanded');
    $('.toggle-btn').not(this).text('＋');

    // 選択したメニューの操作
    $item.toggleClass('is-expanded', willOpen);
    $(this).text(willOpen ? '−' : '＋');
    $menu.slideToggle(300);
  });

  // スマホ用第2階層メニューの操作
  $(document).on('click', '.mobile-toggle-btn', function(e) {
    e.preventDefault();
    const $item = $(this).parent('li');
    const $menu = $item.find('.cGnav__top--2nd');
    const willOpen = !$menu.is(':visible');

    // 他のメニューを閉じる
    $('.cGnav__top--1st > li').not($item).find('.cGnav__top--2nd').slideUp(300);
    $('.cGnav__top--3rd').slideUp(300);
    $('.mobile-toggle-btn').not(this).text('＋');
    $('.toggle-btn').text('＋');
    $('.cGnav__top--2nd > li').removeClass('is-expanded');

    $(this).text(willOpen ? '−' : '＋');
    $menu.slideToggle(300);
  });

  // メニューリンクのクリック処理
  $('.cGnav__top--1st > li > a, .cGnav__top--2nd > li > a').on('click', function(e) {
    if ($(e.target).hasClass('mobile-toggle-btn') || $(e.target).hasClass('toggle-btn')) return;
    if (isMobileSize()) {
      $('.cGnav__wrap').removeClass('clicked');
      $('.cGnav').stop(true).fadeOut(800);
      $('body').removeClass('menu-open');
    }
  });

  // ハンバーガーメニューの処理
  $('.cGnav__btn').click(function() {
    const isOpening = !$('.cGnav__wrap').hasClass('clicked');

    $('.cGnav__wrap').toggleClass('clicked', isOpening);
    $('.cGnav').stop(true)[isOpening ? 'fadeIn' : 'fadeOut'](800);
    $('body').toggleClass('menu-open', isOpening);

    if (!isOpening && isMobileSize()) {
      $('.cGnav__top--2nd, .cGnav__top--3rd').slideUp(300);
      $('.mobile-toggle-btn, .toggle-btn').text('＋');
      $('.cGnav__top--2nd > li').removeClass('is-expanded');
    }
  });

  // 初期化と画面リサイズ時の処理
  setupMenu();
  $(window).on('resize', setupMenu);
});


// slick
$('.cMain__gallery').slick({
  dots: true,
  arrows: true,
  infinite: true,
  speed: 500,
  fade: true,
  cssEase: 'linear',
  autoplay: true,
  autoplaySpeed: 3000,
});

$('.cMain__gallery--full').slick({
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  fade: true,
  cssEase: 'linear',
  autoplay: true,
  autoplaySpeed: 3000,
});

$('.cMain__atelier__ex--photo').slick({
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  fade: true,
  cssEase: 'linear',
  autoplay: true,
  autoplaySpeed: 3000,
});

$('.cMain__kimono--slider').slick({
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  fade: true,
  cssEase: 'linear',
  autoplay: true,
  autoplaySpeed: 3000,
});





